import { format, isSameDay } from 'date-fns'

import { TimeRange } from 'types'

export const formatDateRange = (timeRange: TimeRange, withTime = false) => {
  const dateRangeFormat = withTime ? 'd MMM yyyy HH:mm' : 'd MMM yyyy'

  return isSameDay(timeRange.from, timeRange.to) && !withTime
    ? format(timeRange.from, dateRangeFormat)
    : `${format(timeRange.from, dateRangeFormat)}-${format(
        timeRange.to,
        dateRangeFormat,
      )}`
}
